import { StarSettingsOutlineIcon } from './StarSettingsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AA6C9E76-AC9C-4373-8AC4-F5C706741FC9
 * name star-settings-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-settings-outline.svg
 * tags
 * - Settings 
 */
export const FavoriteSettingsOutlineIcon = StarSettingsOutlineIcon;
export default FavoriteSettingsOutlineIcon